module.exports = __webpack_public_path__ + "static/media/whiteHeartIcon.0081d8fc.svg";